import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import Cafe from "@/assets/cafés.svg";
import Fashion from "@/assets/fashion.svg";
import ATM from "@/assets/atm.svg";
import CustomerServiceDesk from "@/assets/info.svg";
import Entrance from "@/assets/entrance.svg";
import FastFood from "@/assets/fast_food.svg";
import GiftCard from "@/assets/gift_cards.svg";
import HomeTech from "@/assets/home&tech.svg";
import Hypermarket from "@/assets/hypermarkets.svg";
import JewelleryWatches from "@/assets/jewellery_&_watches.svg";
import LostFound from "@/assets/box.svg";
// import LuggageBagDrop from '@/assets/luggage_bag_drop.svg';
import MallManager from "@/assets/manager.svg";
import PrayerRoomMale from "@/assets/prayer_room_female.svg";
import PrayerRoomFemale from "@/assets/prayer_room_male.svg";
import RedCrescent from "@/assets/charity.svg";
import RestroomFemale from "@/assets/female.svg";
import RestroomMale from "@/assets/men.svg";
import Taxi from "@/assets/taxi.svg";
import UberCareem from "@/assets/uber.svg";
import Wifi from "@/assets/wifi.svg";
import Share from "@/assets/coin.svg";
import Wheelchair from "@/assets/wheelchair.svg";
import BabyChangingFemale from "@/assets/changing.svg";
import BabyChangingMale from "@/assets/changing-1.svg";
import FirstAid from "@/assets/first_aid.svg";
import AccessibleParking from "@/assets/accessible-parking.svg";
import FemaleAccessibleToilet from "@/assets/accessible-toilet-F.svg";
import MaleAccessibleToilet from "@/assets/accessible-toilet-M.svg";
import FamilyParking from "@/assets/family-parking.svg";
import Hotel from "@/assets/hotel-solid.svg";
import HotelWhite from "@/assets/hotel-solid-white.svg";
import Facilities from "@/assets/facilities-ultra.svg";
import FacilitiesWhite from "@/assets/facilities-ultra-white.svg";
import { FaBagShopping, FaFaceSmile, FaUtensils } from "react-icons/fa6";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment.svg";
import iFly from "@/assets/ifly.svg";
import LittleExplorers from "@/assets/little-explorers.svg";
import MagicPlanet from "@/assets/magic-planet.svg";
import Snow from "@/assets/snow.svg";
import VoxCinema from "@/assets/vox-cinema.svg";

import Banks from "@/assets/project-assets/banks.svg";
import Books from "@/assets/project-assets/books.svg";
import Electronics from "@/assets/project-assets/electronics.svg";
import FashionAccessories from "@/assets/project-assets/fashions-accessoiries.svg";
import FashionLadies from "@/assets/project-assets/fashionlandies.svg";
import FashionMen from "@/assets/project-assets/fashionmen.svg";
import FashionUnisex from "@/assets/project-assets/fashionunisex.svg";
import Optics from "@/assets/project-assets/optics.svg";
import Speciality from "@/assets/speciality-services.svg";
import SportsWear from "@/assets/project-assets/sportswear.svg";
import ForkKnife from "@/assets/project-assets/fork-knife.svg";
import ElectricCarCharging from "@/assets/project-assets/Electric-car-charging.svg";
import ElectricScooter from "@/assets/project-assets/electric-scooter-station.svg";
import BikeParking from "@/assets/project-assets/bike-parking.svg";
import ParkingAssist from "@/assets/park_assist.svg";
import Stroller from "@/assets/stroller.svg";
import PhoneCharging from "@/assets/key.svg";
import Swimwear from "@/assets/project-assets/swimwear.svg";
import Luggage from "@/assets/project-assets/luggage.svg";
import Pharmacies from "@/assets/project-assets/phamacies.svg";
import ExpectantParking from "@/assets/project-assets/Expectant-mother-parking.svg";
import Bus from "@/assets/project-assets/bus.svg";
import BabyFeeding from "@/assets/baby-feeding.svg";
import ArabicFashion from "@/assets/arabic.svg";
import Desserts from "@/assets/confectionary.svg";
import ValetParking from "@/assets/valet.svg";
import Postbox from "@/assets/postbox-2.svg";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "shop",
    id: "shop",
    color: "185.6,100%,41.8%",
    icon: FaBagShopping,
    items: [
      {
        title: "banks-financial",
        iconImage: Banks,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:df069a33-d428-44e6-8ac2-6bb2c8b84911",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "books-stationery-toys-games-gifts",
        iconImage: Books,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:0b87afd0-3889-4637-8a82-ae5524e7c530",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "electronics-home-mobile",
        iconImage: Electronics,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:9bc4ad22-39e1-47d2-b930-5a3fb5c160f7",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-accessories",
        iconImage: FashionAccessories,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:5d19306d-94fa-4f78-bb31-9734515e55c1",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-arabic",
        iconImage: ArabicFashion,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:5d1f75e9-8ae3-48b6-93ef-51fe290127d4",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-child",
        iconImage: Fashion,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:34939bd4-5374-4c13-b10b-eee23ca452c4",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-ladies",
        iconImage: FashionLadies,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:79f7d28a-cc39-4ef2-81cb-879a62aecaa5",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-men",
        iconImage: FashionMen,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:424442ae-ce3d-4dcb-bce4-dfff6734a5a7",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-unisex",
        iconImage: FashionUnisex,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:7392b3b5-3c70-4e96-920d-73a740be83b7",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "household-furtniture-carpet",
        iconImage: HomeTech,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:83e8548f-e555-4971-9cd2-32bdb3353fb9",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "hypermarket",
        iconImage: Hypermarket,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:b82d3b64-db2f-4f44-aeb2-3339ce019d48",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "jewellery-watches",
        iconImage: JewelleryWatches,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:58534495-233f-4916-ba72-1cc38b28b1b0",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "services-speciality",
        iconImage: Speciality,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:08a9c111-4368-42e8-9672-c6deb2f94d2c",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "lingerie-swimwear",
        iconImage: Swimwear,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:7ba47dec-785f-45dc-9a06-b6678af7ad0e",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "luggage-leather",
        iconImage: Luggage,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:3ab5450d-360d-4087-84f2-54db63760e07",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "optics-sunglasses",
        iconImage: Optics,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:19008582-f90d-4f0b-bf44-0ddc7241c7fb",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "pharmacy-health-fitness-cosmetics-perfumes",
        iconImage: Pharmacies,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:e4bce9cb-a932-43f5-a1de-59d15efaefeb",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "speciality-stores",
        iconImage: Speciality,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:91bad205-ad44-4da2-961f-51c854a7712a",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "sportswear-goods",
        iconImage: SportsWear,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:7a2490e3-fb3e-4a00-8941-12f1802f3b0a",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "dine",
    id: "dine",
    color: "10.6,100%,61.2%",
    icon: FaUtensils,
    items: [
      {
        title: "cafes",
        iconImage: Cafe,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:7bc841c4-24d6-4550-8f81-16457aa83b86",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "chocolates-confectionery-icecream",
        iconImage: Desserts,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:0167178f-92dc-40f5-9218-ebb96cc769de",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fast-food",
        iconImage: FastFood,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:dca222f3-3740-41f7-883b-e8319d7f47ff",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "restaurants",
        iconImage: ForkKnife,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:2efe011c-c309-49e0-b63c-c4392d409603",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "entertainment",
    id: "entertainment",
    color: "284.4,100%,38.4%",
    icon: FaFaceSmile,
    items: [],
  },
  {
    title: "hotels",
    id: "hotels",
    color: "208,100%,33%",
    iconImage: Hotel,
    iconImageAlt: HotelWhite,
    listed: false,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "be10bdce-cd82-4c67-8559-2e6b8e78d587:5ce8d16a-e795-4e2c-802c-083312db4d06",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "40.6,99%,61.4%",
    iconImage: Facilities,
    iconImageAlt: FacilitiesWhite,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:a2995884-c07c-410c-9e69-d567d4b49a96",
        type: "list",
      },
      {
        title: "male-prayer-room",
        iconImage: PrayerRoomMale,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:9177dc8f-08b9-4b23-b8e3-6e60f881f8c9",
        type: "list",
      },
      {
        title: "female-toilet",
        iconImage: RestroomFemale,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:92da5cd1-3753-4126-bf54-7f484b0195d9",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "male-toilet",
        iconImage: RestroomMale,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:e9b27192-1127-47c7-a1af-d68903b549eb",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "atm",
        iconImage: ATM,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:b60235f7-f29c-4bf5-9206-c45bf9026181",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "customer-service-desk",
        iconImage: CustomerServiceDesk,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:bc637053-1d7e-4fbc-bdca-b1d149400c31",
        type: "closest",
      },
      {
        title: "baby-care-room",
        iconImage: BabyFeeding,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:f7d87ca7-8921-4a9a-9f73-fe5177a1cb68",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "baby-changing-room-female",
        iconImage: BabyChangingFemale,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:bd0b6a58-98d3-44b5-9553-bc6f859abc15",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
      },
      {
        title: "baby-changing-room-male",
        iconImage: BabyChangingMale,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:e1e8e84b-f0d6-4dd8-b64c-30bfb24bf6a0",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
      },
      {
        title: "female-accessible-toilet",
        iconImage: FemaleAccessibleToilet,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:3da47adb-5630-4789-a221-23aa1cb0bb04",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: true,
      },
      {
        title: "male-accessible-toilet",
        iconImage: MaleAccessibleToilet,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:ddab7f0b-2d67-4c3b-9da1-420625fdb2ab",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: true,
      },
      {
        title: "taxi-pickup",
        iconImage: Taxi,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:f9aca52d-bef9-4b1d-b659-30c23f58080e",
        ],
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "otaxi",
        iconImage: UberCareem,
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:0d03afcb-ca69-4e1e-bdd0-f909a1cf2cf4",
        ],
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "bus-stop",
        iconImage: Bus,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:8aa59d88-9acd-4b4c-a3d0-ad33d57c58a2",
        type: "list",
      },
      {
        title: "entrance",
        iconImage: Entrance,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:ae618c5c-9ca9-47de-8a2c-9b428658f692",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "valet-parking",
        iconImage: ValetParking,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:59053d2c-fe27-4686-b8ec-20ae3ec2ee9f",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "pod-parking",
        iconImage: AccessibleParking,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:43d5fa25-a519-403a-98ea-88a718ca97a4",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "family-parking",
        iconImage: FamilyParking,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:64685546-ea88-4619-9257-b9c0ac7246fe",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "expectant-mother-parking",
        iconImage: ExpectantParking,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:86e43283-00e9-45f8-a1c3-f55a9f9dfa35",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "electric-car-charging",
        iconImage: ElectricCarCharging,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:14289c5d-db86-4c3e-83f4-60da34b9debe",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "electric-scooter-station",
        iconImage: ElectricScooter,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:6b960494-f80b-4689-8157-6f1be53763a4",
        type: "list",
      },
      {
        title: "bike-parking",
        iconImage: BikeParking,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:19c65ccd-c125-47f7-8873-b8e0d4e48477",
        type: "list",
        excludeFromSearch: true,
      },
      /*{
        title: "parking-pay-station",
        iconImage: ParkingPay,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:6ad5acab-8d99-4abc-86a3-015daa9edd08",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
      },*/
      {
        title: "find-my-car-kiosk",
        iconImage: ParkingAssist,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:cf34c15f-04f4-42f8-8bdc-44580d7db892",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "charity",
        iconImage: RedCrescent,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:d3cb942d-0fa9-4807-a6f6-0a1b159c3b20",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "post-box",
        iconImage: Postbox,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:35b2dcc9-975f-49bf-8118-080de3cf5d4e",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "lost-found",
        iconImage: LostFound,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:bc637053-1d7e-4fbc-bdca-b1d149400c31",
        type: "closest",
      },
      {
        title: "first-aid-room",
        iconImage: FirstAid,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:bc637053-1d7e-4fbc-bdca-b1d149400c31",
        type: "closest",
      },
      {
        title: "phone-charging",
        iconImage: PhoneCharging,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:bc637053-1d7e-4fbc-bdca-b1d149400c31",
        type: "closest",
        excludeFromSearch: true,
      },
      {
        title: "wheelchairs",
        iconImage: Wheelchair,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:40addcd4-2722-4956-a407-8e6a02fb18f7",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
      },
      {
        title: "baby-strollers",
        iconImage: Stroller,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:26c57e94-7df1-4aaa-876e-1e026b0b7f2b",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "gift-card",
        iconImage: GiftCard,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:bc637053-1d7e-4fbc-bdca-b1d149400c31",
        type: "closest",
      },
      {
        title: "mall-management-office",
        iconImage: MallManager,
        id: "03a9ffaa-911e-4497-afe0-7d507983d6f4:06bafeaf-4ee0-4bab-8535-c2393d33d7be",
        type: "closest",
        hideIconUntilSelected: true,
      },
      {
        title: "parking-bays",
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:003b4ecb-7502-49ca-9ca3-9e55d92c036c",
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:1a201a33-bac5-4628-92e3-6dedaa4bd3e1",
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:78a86fde-7050-457a-8a97-94a4e80ae2ca",
        ],
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "vacant",
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:711713bb-ca25-48ba-8e87-4d2ac4dfb2df",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
      },
      {
        title: "others",
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:b9ba7e98-97e7-4ac9-a449-60fd65d6eb0",
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:b9ba7e98-97e7-4ac9-a449-60fd65d6eb06",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
      },
      {
        title: "notlistedbuttobehide",
        id: [],
        type: "list",
        listed: false,
      },
      {
        title: "parking",
        id: [
          "03a9ffaa-911e-4497-afe0-7d507983d6f4:d165695c-18fb-4722-9171-84d964159fdc",
        ],
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "wifi",
        iconImage: Wifi,
        type: "info",
        listed: false,
        content: {
          en: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">We Understand that staying connected is important in today’s world. That’s why we’re excited to offer #Free_ Mall_WiFi to all our shoppers.</p>
						<ul class="mb-4">
							<li>1. Please choose #Free_Mall_WiFi from the list of Wi-Fi networks.</li>
							<li>2. Your device should automatically be taken to our login page.</li>
							<li>3. Enter your details and follow the instructions to gain high-speed internet service.</li>
						</ul>
					`,
          ar: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">نحن نتفهم أن البقاء على اتصال أمر مهم في عالم اليوم.لهذا السبب نحن متحمسون لتقديم خدمة فري وايفاي لجميع المتسوقين لدينا</p>
						<ul>
							<li>من قائمة الشبكات #Free_Mall_WiFi الرجاء اختيار</li>
							<li>يجب أن يتم نقل جهازك تلقائيا إلى صفحة تسجيل الدخول الخاصة بنا</li>
							<li>أدخل بياناتك واتبع التعليمات للحصول على خدمة إنترنت عالي السرعة</li>
						</ul>
					`,
        },
      },
      {
        title: "share",
        iconImage: Share,
        type: "info",
        listed: false,
        content: {
          en: `
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">Join SHARE</a>
						<h3 class="text-2xl font-bold mb-6">Get More At City Centre Mirdif</h3>
						<p class="mb-6">As a member of the SHARE rewards programme, you get cash back in points at all stores and restaurants in City Centre Mirdif and beyond. Join the SHARE programme now – it’s free and will only take you a few minutes.</p>
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">Join SHARE Rewards</a>
					`,
          ar: `
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">سجلوا في تطبيق شير</a>
					<h3 class="text-2xl font-bold mb-6">احصلوا على المزيد في سيتي سنتر مردف</h3>
					<p class="mb-6">تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة نقاط لدى جميع المتاجر والمطاعم في سيتي سنتر مردف وأماكن أخرى خارج المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم لانضمامكم إليه سوى دقائق معدودة.</p>
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">سجلوا في تطبيق شير</a>
					`,
        },
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "entertainment",
  );
  filterCategories[entertainmentIndex].items = items;
};
